module.exports = __webpack_public_path__ + "static/media/logo.11ab0427.png";